<script>    
    import { onMount } from 'svelte';
    import { getApiBase } from './apiBase.js';
    import RefreshDatabaseButtonComponent from "./RefreshDatabaseButtonComponent.svelte";
    import CreateStudentEmailComponent from "./CreateStudentEmailComponent.svelte";
    import AdminRescheduleRequestsComponent from "./AdminRescheduleRequestsComponent.svelte";
    import AdminClassRegistrationRequestsComponent from "./AdminClassRegistrationRequestsComponent.svelte";
    import AdminRegistrationComponent from "./AdminRegistrationComponent.svelte";
    import SendWeeklyScheduleSMS from "./SendWeeklyScheduleSMS.svelte";
    import SelectUsersEmailComponent from "./SelectUsersEmailComponent.svelte";
    import SelectUsersSMSComponent from "./SelectUsersSMSComponent.svelte";
    import TeacherFinderComponent from "./TeacherFinderComponent.svelte";
    import TeacherAvailabilityCapacityComponent from "./TeacherAvailabilityCapacityComponent.svelte";
    import CreateInformationSectionComponent from "./CreateInformationSectionComponent.svelte";
    import InformationSectionsDisplayComponent from "./InformationSectionsDisplayComponent.svelte";
    import NavBarReusable from "./NavbarReusable.svelte";

    const apiBase = getApiBase();

    // State for tab management
    let activeTab = 'reschedule-requests'; // 'reschedule-requests', 'class-registrations', 'send-emails', 'send-bulk-emails', 'send-bulk-sms', 'send-sms', 'find-teachers', 'system-maintenance', 'information-sections', 'view-information-sections'
    let registrationSubTab = 'view-requests'; // 'view-requests', 'create-request'
    let acceptedUnhandledCount = 0;

    function switchTab(tab) {
        activeTab = tab;
        // Refresh count when switching away from class-registrations tab
        if (tab !== 'class-registrations') {
            fetchAcceptedUnhandledCount();
        }
    }

    function openExerciseBank() {
        const currentUrl = window.location.origin;
        window.open(`${currentUrl}/#/exercise-bank`, '_blank');
    }

    function switchRegistrationSubTab(subTab) {
        registrationSubTab = subTab;
    }

    // Function to fetch count of unhandled registrations
    async function fetchAcceptedUnhandledCount() {
        const token = localStorage.getItem('jwtToken');
        try {
            const response = await fetch(`${apiBase}/studentplayground/api/requests/admin-registration-count/`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            
            if (response.ok) {
                const data = await response.json();
                acceptedUnhandledCount = data.accepted_unhandled_count;
            }
        } catch (error) {
            console.error('Error fetching accepted unhandled count:', error);
        }
    }

    // Initialize count on component mount
    onMount(() => {
        fetchAcceptedUnhandledCount();
    });
</script>

<NavBarReusable label="Admin - Communication & Scheduling" />

<div class="tab-navigation">
    <button 
        class="tab-button {activeTab === 'reschedule-requests' ? 'active' : ''}"
        on:click={() => switchTab('reschedule-requests')}
    >
        Reschedule Requests
    </button>
    <button 
        class="tab-button {activeTab === 'class-registrations' ? 'active' : ''}"
        on:click={() => switchTab('class-registrations')}
    >
        <span>Class Registrations</span>
        {#if acceptedUnhandledCount > 0}
            <span class="count-badge">{acceptedUnhandledCount}</span>
        {/if}
    </button>

    <button 
        class="tab-button {activeTab === 'send-emails' ? 'active' : ''}"
        on:click={() => switchTab('send-emails')}
    >
        Send Class Emails
    </button>
    <button 
        class="tab-button {activeTab === 'send-bulk-emails' ? 'active' : ''}"
        on:click={() => switchTab('send-bulk-emails')}
    >
        Send Bulk Emails
    </button>
    <button 
        class="tab-button {activeTab === 'send-bulk-sms' ? 'active' : ''}"
        on:click={() => switchTab('send-bulk-sms')}
    >
        Send Bulk SMS
    </button>
    <button 
        class="tab-button {activeTab === 'send-sms' ? 'active' : ''}"
        on:click={() => switchTab('send-sms')}
    >
        Send SMS
    </button>
    <button 
        class="tab-button {activeTab === 'find-teachers' ? 'active' : ''}"
        on:click={() => switchTab('find-teachers')}
    >
        Find Teachers
    </button>
    <button
        class="tab-button {activeTab === 'teacher-capacity' ? 'active' : ''}"
        on:click={() => switchTab('teacher-capacity')}
    >
        Availability Capacity
    </button>
    <button 
        class="tab-button {activeTab === 'system-maintenance' ? 'active' : ''}"
        on:click={() => switchTab('system-maintenance')}
    >
        Database refresh
    </button>
    <button 
        class="tab-button {activeTab === 'information-sections' ? 'active' : ''}"
        on:click={() => switchTab('information-sections')}
    >
        Bendra Informacija SUBMIT
    </button>
    <button 
        class="tab-button {activeTab === 'view-information-sections' ? 'active' : ''}"
        on:click={() => switchTab('view-information-sections')}
    >
        bendra informacija DISPLAY
    </button>
    <button 
        class="tab-button"
        on:click={openExerciseBank}
    >
        Uzduotys (HERKUS)
    </button>
</div>

{#if activeTab === 'reschedule-requests'}
    <div class="classcontainer">
        <h3>Handle Reschedule Requests</h3>
        <AdminRescheduleRequestsComponent />
    </div>
{:else if activeTab === 'class-registrations'}
    <div class="classcontainer">
        <h3>Class Registration Management</h3>
        
        <!-- Sub-tabs for class registration management -->
        <div class="sub-tab-navigation">
            <button 
                class="sub-tab-button {registrationSubTab === 'view-requests' ? 'active' : ''}"
                on:click={() => switchRegistrationSubTab('view-requests')}
            >
                View Requests
            </button>
            <button 
                class="sub-tab-button {registrationSubTab === 'create-request' ? 'active' : ''}"
                on:click={() => switchRegistrationSubTab('create-request')}
            >
                Create New Request
            </button>
        </div>

        <!-- Sub-tab content -->
        {#if registrationSubTab === 'view-requests'}
            <div class="sub-content">
                <h4>Handle Class Registration Requests</h4>
                <AdminClassRegistrationRequestsComponent />
            </div>
        {:else if registrationSubTab === 'create-request'}
            <div class="sub-content">
                <h4>Create Class Registration Request</h4>
                <AdminRegistrationComponent />
            </div>
        {/if}
    </div>
{:else if activeTab === 'send-emails'}
    <div class="classcontainer">
        <h3>Send Student Emails</h3>
        <CreateStudentEmailComponent />
    </div>
{:else if activeTab === 'send-bulk-emails'}
    <div class="classcontainer">
        <h3>Send Bulk Emails to Users</h3>
        <SelectUsersEmailComponent />
    </div>
{:else if activeTab === 'send-bulk-sms'}
    <div class="classcontainer">
        <h3>Send Bulk SMS to Users</h3>
        <SelectUsersSMSComponent />
    </div>
{:else if activeTab === 'send-sms'}
    <div class="classcontainer">
        <h3>Send Weekly Schedule SMS</h3>
        <SendWeeklyScheduleSMS />
    </div>
{:else if activeTab === 'find-teachers'}
    <div class="classcontainer">
        <h3>Find Teachers</h3>
        <TeacherFinderComponent />
    </div>
{:else if activeTab === 'teacher-capacity'}
    <div class="classcontainer">
        <TeacherAvailabilityCapacityComponent />
    </div>
{:else if activeTab === 'system-maintenance'}
    <div class="classcontainer">
        <h3>Database refresh</h3>
        <RefreshDatabaseButtonComponent />
    </div>
{:else if activeTab === 'information-sections'}
    <div class="classcontainer">
        <h3>Information Sections</h3>
        <CreateInformationSectionComponent />
    </div>
{:else if activeTab === 'view-information-sections'}
    <div class="classcontainer">
        <InformationSectionsDisplayComponent />
    </div>
{/if}

<style>
    .tab-navigation {
        display: flex;
        gap: 10px;
        margin-bottom: 20px;
        flex-wrap: wrap;
    }

    .tab-button {
        padding: 10px 20px;
        border: 1px solid #ccc;
        background: white;
        cursor: pointer;
        border-radius: 8px;
        font-size: 14px;
        display: flex;
        align-items: center;
        gap: 10px;
        position: relative;
    }

    .tab-button.active {
        background: #fab45a;
        color: black;
        border-color: #fab45a;
    }

    .count-badge {
        background-color: #dc3545;
        color: white;
        border-radius: 50%;
        padding: 4px 8px;
        font-size: 12px;
        font-weight: bold;
        min-width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 1;
    }

    .classcontainer {
        padding: 15px;
        background-color: white;
        flex-direction: column;
        margin-bottom: 15px;
        gap: 10px;
        box-shadow: 0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16);
        border-radius: 8px;
        flex: none;
        color: black;
        align-items: flex-start;
    }

    .classcontainer h3 {
        margin: 0 0 15px 0;
        color: #333;
    }

    .classcontainer h4 {
        margin: 0 0 10px 0;
        color: #555;
        font-size: 1.1rem;
        font-weight: 500;
    }

    /* Sub-tab navigation */
    .sub-tab-navigation {
        display: flex;
        gap: 8px;
        margin-bottom: 20px;
        border-bottom: 1px solid #e0e0e0;
        padding-bottom: 10px;
    }

    .sub-tab-button {
        padding: 8px 16px;
        border: 1px solid #ddd;
        background: #f8f9fa;
        cursor: pointer;
        border-radius: 6px;
        font-size: 13px;
        color: #666;
        transition: all 0.2s ease;
    }

    .sub-tab-button.active {
        background: #007bff;
        color: white;
        border-color: #007bff;
    }

    .sub-tab-button:hover:not(.active) {
        background: #e9ecef;
        border-color: #bbb;
    }

    .sub-content {
        margin-top: 15px;
    }

    /* Override nested component styles for cleaner integration */
    :global(.classcontainer .admin-reschedule-requests) {
        max-width: none;
        margin: 0;
        padding: 0;
    }

    :global(.classcontainer .create-student-email) {
        max-width: none;
        margin: 0;
        padding: 0;
    }

    :global(.classcontainer .send-weekly-sms) {
        max-width: none;
        margin: 0;
        padding: 0;
    }

    :global(.classcontainer .refresh-database) {
        max-width: none;
        margin: 0;
        padding: 0;
    }

    :global(.classcontainer .select-users-email-container) {
        max-width: none;
        margin: 0;
        padding: 0;
    }

    :global(.classcontainer .select-users-sms-container) {
        max-width: none;
        margin: 0;
        padding: 0;
    }

    :global(.classcontainer .teacher-finder) {
        max-width: none;
        margin: 0;
        padding: 0;
    }

    :global(.classcontainer .information-section-component) {
        max-width: none;
        margin: 0;
        padding: 0;
    }

    :global(.classcontainer .information-sections-display) {
        max-width: none;
        margin: 0;
        padding: 0;
    }
</style>
